









































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Brand, Tag} from '@/modules/neovehicle/models';
import {FamilyCreateModel, FamilyGroupManagement} from '@/modules/neovehicle/models/family';
import { SocialClass } from '../models/socialClass';

@Component
export default class extends Vue {
  @Prop({required: true})
  public brands: Brand[];

  @Prop({required: true})
  public groups: FamilyGroupManagement[];

  @Prop({required: true})
  public tagsByFamily: Tag[];

  @Prop({required: true})
  public isOpen: boolean;

  @Prop({required: true})
  public isLatam: boolean;

  @Prop({required: true})
  public socialClasses: SocialClass[];

  public family: FamilyCreateModel = {
    idBrand: 0,
    familyName: '',
    idFamilyGroup: 0,
    idSocialClass: null,
  };

  public isOpenInternal: boolean = false;

  public mounted() {
    this.isOpenInternal = this.isOpen;
  }

  public get groupByBrand() {
    return this.groups.filter((x) => x.idBrand === this.family.idBrand);
  }

  public get isValid() {
    return this.family.idFamilyGroup !== 0
      && this.family.idBrand !== 0
      && this.family.familyName.length !== 0;
  }

  public handleCancel() {
    this.$emit('cancel');
  }

  public handleSave() {
    this.$emit('save', this.family);
  }
}
